import { useMutation } from '@tanstack/react-query';

import { useNotificationApi } from '../api';

type ContactUsRequest = {
  causeId: string;
  user: {
    last_name: string;
    first_name: string;
    email: string;
    note: string;
    recaptcha?: string | null;
  };
};

type ContactOrganizerRequest = {
  causeId: string;
  user: {
    last_name: string;
    first_name: string;
    email: string;
    note: string;
    recaptcha?: string | null;
  };
  campaignName: string;
};

const useCreateConsumerContactUs = () => {
  const NotificationsApi = useNotificationApi();

  const createConsumerContactUs = async ({ causeId, user }: ContactUsRequest) => {
    const { data } = await NotificationsApi.post(`/consumer/contact_us?cause_id=${causeId}`, {
      ...user,
      cause_id: causeId,
    });
    return data;
  };

  return useMutation({
    mutationFn: createConsumerContactUs,
  });
};

const useCreateConsumerContactCampaignOrganizer = () => {
  const NotificationsApi = useNotificationApi();

  const createConsumerContactCampaignOrganizer = async ({
    causeId,
    user,
    campaignName,
  }: ContactOrganizerRequest) => {
    const { data } = await NotificationsApi.post(
      `/consumer/contact/organizer?cause_id=${causeId}`,
      {
        ...user,
        cause_id: causeId,
        campaign_name: campaignName,
      }
    );
    return data;
  };

  return useMutation({
    mutationFn: createConsumerContactCampaignOrganizer,
  });
};

export { useCreateConsumerContactCampaignOrganizer, useCreateConsumerContactUs };
